import resource from "../../Util/resources";

const createTooltip = (text, imageName) => {
    //An image should be guaranteed to appear on it's own line
    if(imageName){
        text += `<br /> <img alt="${imageName}" src="/Images/EMV/${imageName}.jpg">`;
    }
    
    return text;
};

const pageSettingsTooltip = createTooltip(resource('TemplateManager_PageSettings_Tooltip'), 'page_tooltip');
const blockSettingsTooltip = createTooltip(resource('TemplateManager_BlockSettings_Tooltip'), 'block_tooltip');
const rowSettingsTooltip = createTooltip(resource('TemplateManager_RowSettings_Tooltip'), 'row_tooltip');
const elementSettingsTooltip = createTooltip(resource('TemplateManager_ElementSettings_Tooltip'), 'element_tooltip');
// const rowSettingsTooltip = createTooltip('', 'row_tooltip');

const imageContentSettingsTooltip = createTooltip(resource('TemplateManager_ImageContentSettings_Tooltip'));

const insertBlockTooltip = createTooltip(resource('TemplateManager_InsertBlock_Tooltip'));
const insertRowTooltip = createTooltip(resource('TemplateManager_InsertRow_Tooltip'));
const insertColumnTooltip = createTooltip(resource('TemplateManager_InsertColumn_Tooltip'));

const settingsRotationRightTooltip = createTooltip(resource('TemplateManager_SettingsRotation_RotateRight_Tooltip'));
const settingsRotationLeftTooltip = createTooltip(resource('TemplateManager_SettingsRotation_RotateLeft_Tooltip'));

const settingsPositionTopLeftTooltip = createTooltip(resource('TemplateManager_SettingsPosition_TopLeft_Tooltip'));
const settingsPositionTopCenterTooltip = createTooltip(resource('TemplateManager_SettingsPosition_TopMiddle_Tooltip'));
const settingsPositionTopRightTooltip = createTooltip(resource('TemplateManager_SettingsPosition_TopRight_Tooltip'));
const settingsPositionMiddleLeftTooltip = createTooltip(resource('TemplateManager_SettingsPosition_MiddleLeft_Tooltip'));
const settingsPositionMiddleCenterTooltip = createTooltip(resource('TemplateManager_SettingsPosition_MiddleCenter_Tooltip'));
const settingsPositionMiddleRightTooltip = createTooltip(resource('TemplateManager_SettingsPosition_MiddleRight_Tooltip'));
const settingsPositionBottomLeftTooltip = createTooltip(resource('TemplateManager_SettingsPosition_BottomLeft_Tooltip'));
const settingsPositionBottomCenterTooltip = createTooltip(resource('TemplateManager_SettingsPosition_BottomCenter_Tooltip'));
const settingsPositionBottomRightTooltip = createTooltip(resource('TemplateManager_SettingsPosition_BottomRight_Tooltip'));

export {
    blockSettingsTooltip,
    pageSettingsTooltip,
    elementSettingsTooltip,
    rowSettingsTooltip,

    imageContentSettingsTooltip,
    
    insertBlockTooltip,
    insertRowTooltip,
    insertColumnTooltip,
    
    settingsRotationRightTooltip,
    settingsRotationLeftTooltip,
    
    settingsPositionTopLeftTooltip,
    settingsPositionTopCenterTooltip,
    settingsPositionTopRightTooltip,
    settingsPositionMiddleLeftTooltip,
    settingsPositionMiddleCenterTooltip,
    settingsPositionMiddleRightTooltip,
    settingsPositionBottomLeftTooltip,
    settingsPositionBottomCenterTooltip,
    settingsPositionBottomRightTooltip
};